import "./App.css";
import About from "./components/About";
import ContactUs from "./components/ContactUs";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Services from "./components/Services";

function IntroToServices() {
  return (
    <section className="intro-to-services py-5 bg-light">
      <div className="container">
  <h2 className="fw-bold text-center mb-4">Why Choose Our Products & Services?</h2>
  <div className="row">
    <div className="col-md-6">
      <p className="lead">
        We specialize in providing a rich blend of traditional craftsmanship and modern elegance
        through our wide range of ethnic sarees, Jaipuri & Jodhpuri printed dress materials, and
        versatile ladies’ garments—be it formal, casual, or nightwear.
      </p>
      <p>
        Our offerings go beyond fashion—we also cater to corporate, hospital, hotel, and educational institutions 
        with high-quality customized uniforms and gifting solutions. Every product is carefully curated or tailored 
        to reflect your identity and brand values.
      </p>
      <p>
        From stylish accessories and vibrant home furnishings to personalized corporate gifts, 
        we bring aesthetics and practicality together. Our team is committed to delivering products 
        that meet the highest standards in both design and functionality.
      </p>
    </div>
    <div className="col-md-6">
      <ul className="list-unstyled">
        <li>
          <strong>Ethnic Elegance:</strong> Explore our exclusive collection of sarees and traditional dress materials 
          inspired by Rajasthani heritage.
        </li>
        <li>
          <strong>Complete Wardrobe Solutions:</strong> From everyday wear to special occasions, 
          we provide all types of ladies' garments including formal wear, nightwear, and stylish accessories.
        </li>
        <li>
          <strong>Tailored Corporate Gifting:</strong> Make a lasting impression with customized gifting options 
          for your team or clients.
        </li>
        <li>
          <strong>Custom Uniforms:</strong> Professionally tailored uniforms for corporates, hospitals, 
          schools, and hospitality businesses—made to reflect your values and maintain comfort.
        </li>
        <li>
          <strong>Home Styling:</strong> Refresh your spaces with our curated home furnishing collections 
          and décor accessories that blend utility with elegance.
        </li>
      </ul>
    </div>
  </div>
</div>

    </section>
  );
}

// In your App component
function App() {
  return (
    <>
      <Navbar />
      <main>
        <Home />
        <IntroToServices />
        <Services />
        <About />
        <ContactUs />
      </main>
    </>
  );
}

export default App;
